module.exports = __webpack_public_path__ + "static/media/fsk6.43db171e.jpg";